import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getHotelDetails } from '../../../services/hotel/hotelServices';
import moment from 'moment';
import HotelReviewTbo from '../HotelDetailsTbo/HotelReviewTbo';
import HotelReviewTripjack from '../HotelDetailsTripjack/HotelReviewTripjack';
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Modal } from 'antd';

const TripjeckTBOHotelReview = () => {
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [hotelDetails, setHotelDetails] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [roomInfo, setRoomInfo] = useState(null);

    const [bookingMessage, setBookingMessage] = useState(null)
    const [bookingMessageError, setBookingMessageError] = useState(false)
    const navigate = useNavigate();

    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");
    const TraceId = queryParams.get("TraceId");
    const ResultIndex = parseInt(queryParams.get("ResultIndex"));
    const HotelCode = queryParams.get("HotelCode");
    const vendor = queryParams.get("vendor");

    const extractBedType = (roomTypeName) => {
        const parts = roomTypeName?.split(',');
        const bedPart = parts?.find(part => /bed/i.test(part));
        return bedPart ? bedPart.trim() : null;
    };

    const roomSize = (roomDescription) => {
        const match = roomDescription?.match(/(\d+)\s*sq\s*feet/i);
        return match ? `${match[1]} sq feet` : null;
    };

    // useEffect(() => {
    //     const fetchHotelDetails = async () => {
    //         const storedStartDate = localStorage.getItem("startDate");
    //         const storedEndDate = localStorage.getItem("endDate");
    //         const storedRoomInfo = localStorage.getItem("roomInfo");

    //         if (storedStartDate) {
    //             const formattedStartDate = moment(storedStartDate, [
    //                 "MMM DD, YYYY",
    //                 "YYYY-MM-DD",
    //             ]).format("MMM DD, YYYY");
    //             setStartDate(formattedStartDate);
    //         }

    //         if (storedEndDate) {
    //             const formattedEndDate = moment(storedEndDate, [
    //                 "MMM DD, YYYY",
    //                 "YYYY-MM-DD",
    //             ]).format("MMM DD, YYYY");
    //             setEndDate(formattedEndDate);
    //         }
    //         if (storedRoomInfo) setRoomInfo(JSON.parse(storedRoomInfo));

    //         try {
    //             setLoading(true);
    //             const payload = { id, TraceId, ResultIndex, HotelCode, vendor };
    //             const resp = await getHotelDetails(payload);
    //             setHotelDetails(resp.data);
    //         } catch (error) {
    //             console.error("Error fetching hotel details:", error?.response?.data?.message);
    //             setBookingMessageError(true)
    //             setBookingMessage(error?.response?.data?.message)
    //         } finally {
    //             setLoading(false);
    //         }
    //     };

    //     if (id && HotelCode && vendor) {
    //         fetchHotelDetails();
    //     }
    // }, [id, TraceId, ResultIndex, HotelCode, vendor]);


    useEffect(() => {
        const fetchHotelDetails = async () => {
            const storedStartDate = localStorage.getItem("startDate");
            const storedEndDate = localStorage.getItem("endDate");
            const storedRoomInfo = localStorage.getItem("roomInfo");

            if (storedStartDate) {
                const formattedStartDate = moment(storedStartDate, [
                    "MMM DD, YYYY",
                    "YYYY-MM-DD",
                ]).format("MMM DD, YYYY");
                setStartDate(formattedStartDate);
            }

            if (storedEndDate) {
                const formattedEndDate = moment(storedEndDate, [
                    "MMM DD, YYYY",
                    "YYYY-MM-DD",
                ]).format("MMM DD, YYYY");
                setEndDate(formattedEndDate);
            }

            if (storedRoomInfo) setRoomInfo(JSON.parse(storedRoomInfo));

            try {
                setLoading(true);

                const payload = { id, TraceId, ResultIndex, HotelCode, vendor };
                const resp = await getHotelDetails(payload);
                if (
                    resp?.data?.GetHotelRoomResult?.ResponseStatus === 4 ||
                    resp?.data?.Error?.ErrorMessage
                ) {
                    const tboError =
                        resp?.data?.Error?.ErrorMessage ||
                        resp?.data?.GetHotelRoomResult?.Error?.ErrorMessage
                    setBookingMessageError(true);
                    setBookingMessage(tboError);
                    return;
                }
                setHotelDetails(resp.data);
            } catch (error) {
                console.error("Error fetching hotel details:", error);
                const errorMsg =
                    error?.response?.data?.message ||
                    error?.response?.data?.Error?.ErrorMessage ||
                    "Something went wrong while fetching hotel details.";

                setBookingMessageError(true);
                setBookingMessage(errorMsg);
            } finally {
                setLoading(false);
            }
        };

        if (id && HotelCode && vendor) {
            fetchHotelDetails();
        }
    }, [id, TraceId, ResultIndex, HotelCode, vendor]);


    const totalNOAdults = roomInfo?.reduce((total, room) => total + room.numberOfAdults, 0);
    const totalNOChildren = roomInfo?.reduce((total, room) => total + room.numberOfChild, 0);
    const totalRooms = roomInfo?.length;

    const handleGoBack = () => {
        if (window.opener && !window.opener.closed) {
            const parent = window.opener;
            parent.location.reload(true);
            setTimeout(() => {
                parent.location.href = parent.location.href;
            }, 100);
            setTimeout(() => {
                parent.location.replace(parent.location.pathname + parent.location.search);
            }, 200);

            parent.focus();
        }
        setTimeout(() => {
            window.close();
        }, 2000);
    };

    return (
        <>
            {vendor === "TBO" &&
                <HotelReviewTbo
                    loading={loading}
                    hotelDetails={hotelDetails}
                    startDate={startDate}
                    endDate={endDate}
                    totalNOAdults={totalNOAdults}
                    totalNOChildren={totalNOChildren}
                    totalRooms={totalRooms}
                    extractBedType={extractBedType}
                    roomSize={roomSize}
                    ResultIndex={ResultIndex}
                    vendor={vendor}
                />
            }

            {vendor === "TRIPJACK" &&
                <HotelReviewTripjack
                    loading={loading}
                    hotelDetails={hotelDetails}
                    vendor={vendor}
                    totalRooms={totalRooms}
                />
            }

            <Modal
                className='Gallery_cntr p-3'
                open={bookingMessageError}
                footer={null}
                onCancel={() => {
                    setBookingMessageError(false);
                    navigate(-1);
                }}
                centered
                destroyOnClose={true}
                width={400}
            >
                <div className='text-center py-4' >
                    <h4 className='mb-1'>Uh Oh!</h4>
                    <h4 style={{ color: "red" }}>{bookingMessage}</h4>
                    {/* <button
                        onClick={() => window.close()}
                        className='btn btn-primary py-2 d-block mt-3 border-0 m-auto' aria-label="ok got it">
                        Go Back
                    </button>
                </div> */}
                    <button
                        onClick={handleGoBack}
                        className='btn btn-primary py-2 d-block mt-3 border-0 m-auto' aria-label="ok got it">
                        Go Back
                    </button>
                </div>
            </Modal>
        </>



    );
};

export default TripjeckTBOHotelReview;